export const getRegisterViewAction = "MEMBER/GET/REGISTER_VIEW";
export const getRegisterViewSuccessAction = "MEMBER/GET/REGISTER_VIEW/SUCCESS";
export const getRegisterViewFailAction = "MEMBER/GET/REGISTER_VIEW/FAIL";
export const getRegisterViewResetAction = "MEMBER/GET/REGISTER_VIEW/RESET";

export const getRegisterSettingAction = "REGISTER/SETTINGS";
export const getRegisterSettingSuccessAction = "REGISTER/SETTINGS/SUCCESS";
export const getRegisterSettingFailAction = "REGISTER/SETTINGS/FAIL";
export const getRegisterSettingResetAction = "REGISTER/SETTINGS/CLEAR";
